import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import logo from '../assets/icon.png';

const NavContainer = styled(motion.nav)`
  position: sticky;
  top: 0;
  width: 100%;
  height: 70px;
  background: rgba(239, 238, 238, 0.53);
  backdrop-filter: blur(8px);
  z-index: 1000;
  border-bottom: 1px solid rgba(201, 201, 201, 0.46);
`;

const NavContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 2rem;
`;

const Logo = styled.img`
  height: 50px;
  width: auto;
  cursor: pointer;
  padding: 5px 0;
`;

const LogoLink = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
`;

const NavLinks = styled.div`
  display: flex;
  gap: 3rem;
`;

const NavLink = styled(Link)`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 1.1rem;
  color: #333;
  text-decoration: none;
  position: relative;
  padding: 0.5rem 0;
  transition: all 0.3s ease;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 2px;
    background: #007AFF;
    transition: width 0.3s ease;
  }

  &:hover {
    color: #007AFF;
    font-weight: 500;

    &::after {
      width: 100%;
    }
  }
`;

const Navbar = () => {
  return (
    <NavContainer
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <NavContent>
        <LogoLink to="/">
          <Logo src={logo} alt="Website Logo" />
        </LogoLink>
        <NavLinks>
          <NavLink to="/">Home</NavLink>
          <NavLink to="/projects">Projects</NavLink>
          <NavLink to="/blog">Blog</NavLink>
        </NavLinks>
      </NavContent>
    </NavContainer>
  );
};

export default Navbar;
